import { Operator } from '@jexop/core';

export const arrayJoinOperator: Operator<string> = (props) => {
  const { value, separator = ' ' } = props as { value: string[]; separator?: string };
  if (!Array.isArray(value)) return '';
  return value.join(separator);
};

export const arrayLengthOperator: Operator<number> = (props) => {
  const { value } = props as { value: unknown[] };
  if (!Array.isArray(value)) return null;
  return value.length;
};

export const arrayIncludesOperator: Operator<boolean> = (props) => {
  const { array, value } = props as { array: unknown[]; value: unknown };
  if (!Array.isArray(array)) return false;
  return array.includes(value);
};

export const arrayIncludesOnlyOperator: Operator<boolean> = (props) => {
  const { array, value } = props as { array: unknown[]; value: unknown };
  if (!Array.isArray(array)) return false;
  return array.length === 1 && array.includes(value);
};

export const arrayConcatOperator: Operator<unknown[]> = (props: Record<string, unknown>) => {
  const arrays = props.arrays;
  if (!Array.isArray(arrays)) return [];

  return arrays.reduce((acc: unknown[], item) => {
    if (Array.isArray(item)) {
      acc.push(...(item as unknown[]));
    }
    return acc;
  }, []);
};
